module.exports = __webpack_public_path__ + "static/media/plus-circle.7e38d24b.svg";